<div [id]="getId()" class="modal" role="dialog" tabindex="-1">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <div [innerHTML]="modalable?.quicklink | quicklinkNumberHtml" class="quicklink"></div>
                <button (click)="openExercise()" class="btn btn-round btn-inverted-purple">Aufgabe öffnen <i
                        class="fa fa-arrow-up"></i></button>
                <button class="btn-close" data-bs-dismiss="modal" title="Schließen" type="button"></button>
            </div>
            <div class="modal-body">
                <img [alt]="modalable?.quicklink" [src]="preview">
            </div>
            <div class="modal-footer">
                @if (modalable?.addingAllowed) {
                    <button (click)="addExercise()" class="btn btn-round btn-inverted-green" type="button">zur
                        Aufgabenliste hinzufügen <img [src]="'icon-hsm-plusbutton.png' | asset" alt="Plus"></button>
                }
            </div>
        </div>
    </div>
</div>
